export default __webpack_public_path__ + "static/media/liqiang.1c128b01.jpg";